module.exports = __webpack_public_path__ + "img/22.6a8cb50b.png";